// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5090c62e","455":"044ff31f","476":"578e7ac1","977":"2bd2741e"}[chunkId] + ".chunk.js";
};